import {Typography} from "@mui/material";

export const PatientConnectCardTitle: React.FC = () => (
  <Typography variant="body1" component="div" sx={{ fontWeight: 'bold', fontSize: '1rem', lineHeight: 1.2 }}>
    Patient Connect
  </Typography>
);
